module.exports = __webpack_public_path__ + "static/media/logo.f97de90b.png";